export async function getLandMap() {
        var map = new window.GeosamaraMap();
        map.domain = "https://rk.geosamara.ru";
        map.page = "/base_map/";
        map.modules = "Map";
        map.instruments = "ScaleInstrument,MoveInstrument";
        map.wms = "/tms53,/tms51,/tms52,/tms56,/tms54,/tms55,/wms1";
        map.wfs = "/wfs1";
        map.settings = "/settings1";
        map.layers = "tms51_layer,RN_1_3:avgWeight";
        map.scalesList = "2.24E9,1.12E9,5.59082264E8,2.79541132E8,1.39770566E8,6.9885283E7,3.49426415E7,1.747132075E7,8735660.375,4367830.188,2183915.094,1091957.547,545978.7735,272989.3867,136494.6934,68247.34668,34123.67334,17061.83667,8530.918335,4265.459168,2132.729584,1066.364792";
        map.scale = 15;
        map.x = 5583362.0;
        map.y = 7023263.0;
        map.selected = ""
        map.showOnlyListedLayers = true;
        await map.insert("mapContainerLand");
        return map
}
export async function getBaseMap(x = 5576085.0, y = 7017524.0, defaultLayers = "tms51_layer", scale = 6) {
        var map = new window.GeosamaraMap();
        map.domain = "https://rk.geosamara.ru";
        map.page = "/base_map/";
        map.modules = "Map,MarkersList,Toolbar,LayersList,Messenger";
        map.instruments = "ScaleInstrument,MoveInstrument,TextRequest,LinkToThisPlace,JSIntegration,RKTables,Legenda";
        map.wms = "/tms53,/tms51,/tms52,/tms56,/tms54,/tms55,/wms1";
        map.wfs = "/wfs1";
        map.settings = "/settings1";
        map.layers = defaultLayers;
        map.scalesList = "2.24E9,1.12E9,5.59082264E8,2.79541132E8,1.39770566E8,6.9885283E7,3.49426415E7,1.747132075E7,8735660.375,4367830.188,2183915.094,1091957.547,545978.7735,272989.3867,136494.6934,68247.34668,34123.67334,17061.83667,8530.918335,4265.459168,2132.729584,1066.364792";
        map.scale = scale;
        map.x = x;
        map.y = y;
        map.selected = ""
        await map.insert("mapContainer");
}